import React, { useEffect, useState } from "react"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import Card from "@material-ui/core/Card"
import CardHeader from "@material-ui/core/CardHeader"
import CardMedia from "@material-ui/core/CardMedia"
import CardContent from "@material-ui/core/CardContent"
import CardActions from "@material-ui/core/CardActions"
import Typography from "@material-ui/core/Typography"
import { red } from "@material-ui/core/colors"
import Button from "@material-ui/core/Button"
import Menu from "@material-ui/core/Menu"
import MenuItem from "@material-ui/core/MenuItem"
import moreIcon from "../../utils/icons/more-icon.svg"
import { Divider, Grid, IconButton, ListSubheader } from "@material-ui/core"
import { ModalPopup } from "../modal"
import { UploadFiles, KbMaking } from "../bifrost"
import { useDispatch, useSelector } from "react-redux"
import { extractFileRequest, extractFileRequestClear } from "../../actions/bifrostActions"
import { useHistory } from "react-router-dom"
import { getStatusColor, CASE_ACTIVITY } from "../../utils"
import { useTranslation } from "react-i18next"
import moment from "moment"

const useStyles = makeStyles((theme) => ({
	root: {
		//maxWidth: 475,
		boxShadow: theme.shadows[26],
	},
	cardTitleSection: { display: "flex", alignItems: "center" },
	cardTitle: {
		fontSize: 17,
		marginLeft: "8px",
		maxWidth: "250px",
	},
	action: {
		margin: 0,
		alignSelf: "center",
	},
	divider: {
		// Theme Color, or use css color in quote
		background: theme.palette.grey.D1400,
	},
	actionsButtons: {
		display: "flex",
		justifyContent: "flex-end",
		alignItems: "center",
		borderTop: `1px solid ${theme.palette.grey.D1400}`,
		padding: "12px 24px 12px 12px",
		"& .MuiButtonBase-root.Mui-disabled": {
			background: theme.typography.button.disabledColor,
			color: theme.palette.grey.D100,
			border: `1px solid ${theme.typography.button.disabledColor}`,
		},
	},
	actionBtn: {
		textTransform: "initial",
		fontSize: 17,
		color: theme.palette.primary.dark,
		border: `solid 1px ${theme.palette.primary.dark}`,
		fontWeight: 500,
	},
	description: {
		minHeight: 18,
		color: theme.palette.grey.D100,
	},
	detailsValue: {
		color: theme.palette.text.primary,
		fontWeight: 500,
	},
	cardDetailsHeader: {
		display: "flex",
		width: "100%",
		justifyContent: "space-between",
		fontStyle: "italic",
		margin: "4px 16px 0 16px",
	},
	menuDetails: {
		display: "flex",
		width: "100%",
		justifyContent: "space-between",
		margin: "12px 0 12px 0",
	},
	caseDetailsSection: {
		width: "100%",
		height: "175px",
		overflowY: "auto",
		padding: "0 16px 0 16px",
		"&:hover .MuiListItem-button": {
			cursor: "initial",
			background: "initial",
		},
	},
	fileDetailsSection: {
		display: "flex",
		width: "100%",
		justifyContent: "space-between",
		cursor: "initial",
		background: "initial",
	},
	nameStatusWrapper: {
		display: "flex",
		alignItems: "center",
	},
	caseName: {
		display: "inline-block",
		width: "150px",
		overflow: "hidden",
		textOverflow: "ellipsis",
	},
	caseStatus: {
		display: "inline-block",
		maxWidth: "150px",
		borderRadius: "3px",
		padding: "2px 4px",
		marin: "0 10px 0 4px",
		textTransform: "capitalize",
		overflow: "hidden",
		textOverflow: "ellipsis",
		marginLeft: "8px",
		fontSize: "16px",
		fontWeight: "400",
	},
	noCaseDetailsSection: {
		marginLeft: "16px",
	},
}))

const Case = ({ data }) => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const history = useHistory()
	const [t] = useTranslation("global")
	const theme = useTheme()

	const isExtracting = useSelector((state) => state.bifrostCase.extract)

	const [openUploadModal, setOpenUploadModal] = useState(false)
	const [openKbMakingModal, setOpenKbMakingModal] = useState(false)
	const [isActionBtnDisabled, setActionBtnDisabled] = useState(false)

	const [anchorEl, setAnchorEl] = React.useState(null)

	useEffect(() => {
		if (data && Object.keys(data).length) {
			let actionBtnDisabledStatus = data.case_mode === "Active" || !data?.current_activity === CASE_ACTIVITY.IDLE
			setActionBtnDisabled(actionBtnDisabledStatus)
		}
	}, [])

	useEffect(() => {
		if (isExtracting[data?.case_id]?.isExtracted) {
			history.push(`/bifrost/case/${data.case_id}`)
			dispatch(extractFileRequestClear(data.case_id))
		}
	}, [isExtracting])

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget)
	}

	const handleClose = () => {
		setAnchorEl(null)
	}

	const closeCreateCaseModal = (status = false) => {
		setOpenUploadModal(false)
	}

	const handleUpload = () => {
		setOpenUploadModal(true)
	}

	const handleExtract = (e, data) => {
		e.preventDefault()
		const payload = {
			name: data.name,
			case_id: data.case_id,
		}
		dispatch(extractFileRequest(payload))
	}

	const handleKbMaking = (open) => {
		setOpenKbMakingModal(open)
	}

	const handleHeaderClick = (e) => {
		e.preventDefault()
		history.push(`/bifrost/case/${data.case_id}`)
	}

	const formatDate = (date) => {
		return new Date(date).toLocaleString()
	}

	const generateMenuList = () => {
		if (data?.job_details.length) {
			return (
				<>
					{data.job_details.map((caseData) => {
						return (
							<MenuItem className={classes.menuDetails}>
								<Grid item className={classes.nameStatusWrapper}>
									<span className={classes.caseName}>{caseData?.name}</span>
									<span
										className={classes.caseStatus}
										style={{
											color: getStatusColor(caseData?.status, theme).color,
											backgroundColor: getStatusColor(caseData?.status, theme).background,
										}}
									>
										{caseData?.status}
									</span>
								</Grid>
								<Grid item>
									<span>{formatDate(caseData?.create_time)}</span>
								</Grid>
							</MenuItem>
						)
					})}
				</>
			)
		} else {
			return (
				<Grid className={classes.noCaseDetailsSection}>
					<span>No jobs created.</span>
				</Grid>
			)
		}
	}
	return (
		<Card className={classes.root}>
			<CardHeader
				title={
					<div className={classes.cardTitleSection}>
						<Typography onClick={handleHeaderClick} gutterBottom variant="h6" className={classes.cardTitle}>
							{data.name}
						</Typography>
						<span
							className={classes.caseStatus}
							style={{
								color: getStatusColor(data.case_mode, theme).color,
								backgroundColor: getStatusColor(data.case_mode, theme).background,
							}}
						>
							{data.case_mode}
						</span>
					</div>
				}
				style={{
					borderBottom: `1px solid ${theme.palette.grey.D1400}`,
					minHeight: 80,
					cursor: "pointer",
				}}
				classes={{ action: classes.action }}
				className={classes.action}
				//Keeping this for future reference
				// action={
				// 	<>
				// 		<IconButton aria-label="settings" onClick={handleClick}>
				// 			<img src={moreIcon} alt="more" />
				// 		</IconButton>
				// 		<Menu id="action-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
				// 			<MenuItem onClick={handleClose}>Action 1</MenuItem>
				// 			<MenuItem onClick={handleClose}>Action 2</MenuItem>
				// 			<MenuItem onClick={handleClose}>Action 3</MenuItem>
				// 		</Menu>
				// 	</>
				// }
			/>

			<CardMedia className={classes.media} image="/static/images/cards/paella.jpg" title="Paella dish" />
			<CardContent style={{ padding: "0px" }}>
				<Grid container spacing={2}>
					<ListSubheader className={classes.cardDetailsHeader}>
						<Grid item>
							<span>{t("bifrost.case.recentJobs")}</span>
						</Grid>
						<Grid item>
							<span>{t("bifrost.case.jobTrigger")}</span>
						</Grid>
					</ListSubheader>
					<section className={classes.caseDetailsSection}>{generateMenuList()}</section>
					<section
						style={{
							width: "100%",
							borderTop: `solid 1px ${theme.typography.button.disabledColor}`,
							padding: "4px 16px 8px 16px",
						}}
					>
						<MenuItem className={classes.fileDetailsSection}>
							<Grid item>
								<Typography variant="body2" color="textSecondary" component="p" className={classes.description}>
									{t("bifrost.case.overallSize")}
								</Typography>
								<Typography variant="body2" color="textSecondary" component="p" className={classes.detailsValue}>
									{data?.total_bfiles_size ? data.total_bfiles_size : "-"}
								</Typography>
							</Grid>
							<Grid item style={{ textAlign: "right" }}>
								<Typography variant="body2" color="textSecondary" component="p" className={classes.description}>
									{t("bifrost.case.overallCount")}
								</Typography>
								<Typography variant="body2" color="textSecondary" component="p" className={classes.detailsValue}>
									{data?.total_bfiles_count ? data?.total_bfiles_count : "-"}
								</Typography>
							</Grid>
						</MenuItem>
					</section>
				</Grid>
			</CardContent>
			<CardActions className={classes.actionsButtons}>
				<Button
					size="medium"
					disabled={isActionBtnDisabled}
					variant="outlined"
					color="primary"
					className={classes.actionBtn}
					onClick={(e) => handleUpload(e, data)}
				>
					{t("bifrost.case.upload")}
				</Button>
				<Button
					size="medium"
					disabled={isActionBtnDisabled}
					variant="outlined"
					color="primary"
					className={classes.actionBtn}
					onClick={(e) => handleExtract(e, data)}
				>
					{isExtracting[data?.case_id]?.isExtracting ? t("bifrost.case.extracting") : t("bifrost.case.extract")}
				</Button>
				<Button
					size="medium"
					disabled={isActionBtnDisabled}
					variant="outlined"
					color="primary"
					className={classes.actionBtn}
					onClick={() => handleKbMaking(true)}
				>
					{t("bifrost.case.kbMaking")}
				</Button>
			</CardActions>

			<ModalPopup title={"Upload documents"} open={openUploadModal} setOpen={setOpenUploadModal} outSideClickClose>
				<UploadFiles callback={closeCreateCaseModal} data={data} />
			</ModalPopup>
			<ModalPopup title={t("bifrost.titles.createKb")} open={openKbMakingModal} setOpen={setOpenKbMakingModal} outSideClickClose>
				<KbMaking callback={handleKbMaking} data={data} />
			</ModalPopup>
		</Card>
	)
}

export default Case
